<template>
    <span>
    <span v-if="isRuleLoaded()">
        <span v-if="filterIndex >0 &&  filterIndex < aiRules.length" class="filter-condition">
                <span class="filter-type">{{ conditionText }}</span>
            </span>
        <template v-for="(readAbleString,indexKey) in filterObject.filters.stringData">
            <div 
                class="readable-parent py-5"
                :class="[indexKey>0 ? 'pt-0': '']"
            >
                <template v-for="(filterValue,stringKey) in readAbleString">
                    <div 
                        :key="indexKey+stringKey" 
                        class="d-flex text-background filter-width "
                        :class="[stringKey == 0 && indexKey == 0 ? 'text-capitalize' : 'lower-case',indexKey == 0 ? 'box-width' : '']"
                    > 
                            <span
                                class="text--darken-2"
                                :class="indexKey == 0 ? 'text-truncate' : ''"
                                v-html="filterValue.text ? filterValue.text : filterValue "
                            />  
                            
                            <span v-if="filterValue.text" class="tooltip-info" v-html="filterValue.text"/> 
                    </div>
                </template>
            </div>
            
        </template>
    </span>
    <v-col cols="12" class="d-flex" v-if="!isRuleLoaded()">
        <v-skeleton-loader
            class="mx-auto border"
            type="chip"
            ></v-skeleton-loader> <v-skeleton-loader
            class="mx-auto border"
            type="chip"
            ></v-skeleton-loader> <v-skeleton-loader
            class="mx-auto border"
            type="chip"
            ></v-skeleton-loader> <v-skeleton-loader
            class="mx-auto border"
            type="chip"
            ></v-skeleton-loader> 
            
        </v-col>
    </span>
</template>

<script>
import { getReadableString,checkApiCall,replaceReadableTags } from '../scripts/CommonFunction'
export default{
    name: 'aiReadableChips',
    props :{
        filterObject :{
            type: Object,
            default : () => ({})
        },
        conditionText:{
            type: String,
            default : () => 'OR'
        },
        filterIndex:{
            type:Number,
            default : () => 0
        },
        aiRules:{
            type: Array,
            default : () => ([])
        }
    },
    data(){
        return {
            tempIndex:0
        }
    },
    methods:{
        isRuleLoaded(){
            if(checkApiCall(this.filterObject.allFilters[0].children,this.filterObject) ||this.filterObject.childLoaded){
                    if(!this.filterObject.filters || typeof this.filterObject.filters != 'object')
                        this.filterObject.filters = {}
                    let readbaleString = getReadableString(this.filterObject)
                    this.filterObject.filters.stringData = replaceReadableTags(readbaleString)
                    return true
                
            }
            return false
        }
    }
}
</script>

<style lang="scss" scoped>
    .text-background{
        background: #C7EFFF;
        padding: 10px 12px;
        line-height: 24px;
        border-radius: 4px;
        margin: 5px;
        font-size: 16px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.5px;
        position: relative;
    }
    .readable-strings{
        width: calc(100% - 100px);
    }
    .readable-parent{
        display: flex;
        flex-wrap: wrap;
    }
    .tooltip-info {
        position: absolute;
        left: 0;
        width: 100%;
        max-width: 600px;
        max-height: 300px;
        background-color: #000000d4;
        color: #fff;
        padding: 10px;
        border-radius: 10px;
        overflow: auto;
        overflow-x: hidden;
        top: -38px;
        display: none;
        z-index: 9;
    }
    .text-background:hover .tooltip-info {
        display: block;
    }
    .load-more-item{
        color: var(--button-state-enabled, #1E2533);
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; 
        letter-spacing: 0.55px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline;
    }

    .filter-condition{
    width:100%;
    padding: 22px 0px;
    position: relative;
}

.filter-condition:before{ 
    position: absolute;
    content: '';
    top: -4px;
    left:40px;
    width: 1.5px;
    height: calc(100% + 8px);
    background-color: #d4ecf7;
}
.filter-condition.or-condition:before{
    left: 36px;
}
.rule-condition:before{ 
    top: -30px;
    left: 43px;
    height: calc(100% + 60px);
    background: #545C6C;
}
.rule-condition.or-condition:before{
    left: 36px;
}

.rule-condition .filter-type {
  background: #545C6C;
  color: white;
}
.filter-type{
    width:auto;
    background: #d4ecf7;
    border-radius: 20px;
    padding: 7px 24px;
    font-weight: 600;
    line-height: 24px;
    position: relative;
    text-align: center;
    letter-spacing: 0.55px;
    color: rgba(0, 0, 0, 0.6);
    margin: 20px 5px;    
    font-size: 16px;
    font-family: Montserrat;
    font-style: normal;

}
.filter-option{
    background-color: #E5EAEF;
    color: #fff;
    cursor: pointer;
}
.v-skeleton-loader__chip {
    border-radius: 5px!important;
    height: 36px;
    width: 108px;
}
</style>